import { render, staticRenderFns } from "./examples.vue?vue&type=template&id=752b9ad6"
import script from "./examples.vue?vue&type=script&lang=js"
export * from "./examples.vue?vue&type=script&lang=js"
import style0 from "./examples.vue?vue&type=style&index=0&id=752b9ad6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752b9ad6')) {
      api.createRecord('752b9ad6', component.options)
    } else {
      api.reload('752b9ad6', component.options)
    }
    module.hot.accept("./examples.vue?vue&type=template&id=752b9ad6", function () {
      api.rerender('752b9ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/examples.vue"
export default component.exports